import { confirmPlus } from '../common/custom_confirm';
import { LocationDocumentation } from './location_documentation';
import {ReactivateLocation, DeactivateLocation} from './location_inactivate'
import {DataBinder} from '../../utils/data_binder'

export class LocationSettings extends HTMLElement {
  constructor() {
    super();
  }

  async connectedCallback() {

    this.domain_id = document.querySelector("#object_id").value;
    let res = await fetch(`/admin/domains/${this.domain_id}.json`);
    let json = await res.json();
    this.innerHTML = 
      `
      <div id="location-settings-content"></div>
      `;
    let general_settings = new GeneralSettings(json, this.domain_id);
    this.querySelector('#location-settings-content').appendChild(general_settings);
  }
}

customElements.define('location-settings', LocationSettings)

class GeneralSettings extends HTMLElement {
  constructor(data, domain_id) {
    super();
    this.data = data;
    this.autocomplete = null;
    this.street_number = data.site.street_number;
    this.street_name = data.site.street_name;
    this.location_city = data.site.location_city;
    this.location_state = data.site.location_state
    this.zip_code = data.site.zip_code;
    this.country = data.site.country;
    this.latitude = data.site.latitude;
    this.longitude = data.site.longitude;
    this.domain_id = domain_id;
  }

  async connectedCallback() {
    let binder = new DataBinder(`/admin/groups/${this.data.site.owner_auto_group_id}/permissions`, true)
    await binder.fetchData();
    this.permissions = binder.data;
    $(".campaign-footer").hide();

    let groupPills = this.data.site.auto_groups.map(obj => `<span class="badge badge-pill badge-secondary">${obj.name}</span>`).join(' ');
    this.innerHTML = 
      `
      <style>
      .btn-group>.dropdown-menu {
        font-size: 14px;
        min-width: 120px;
        z-index: 1;
        appearance: none;
        top: 25px;
      }

      .btn-group>.dropdown-menu>.active>a, .dropdown-menu>.active>a:hover, .dropdown-menu>.active>a:focus {
        background-color:black !important;
        color:#f4f4f4;
      }

      .btn-group>.dropdown-menu> li> a:hover{
        background-color:#f4f4f4 !important;
      }

      .caret-off::before {
        display: none;
      }

      .caret-off::after {
        display: none;
      }

      .location-settings-main {
        padding: 8px 30px !important;
      }

      #location-groups {
        display: flex;
        justify-content: space-between;
      }
      </style>


      <div class="location-settings-main col-md-12 col-lg-8">
        <div class="pull-left"><h3>General Settings</h3></div>
      </div>

      <div id="cancelled-location-container"></div>

      <div id="general-settings-main" class="row location-settings-main col-md-12 col-lg-8">
        <div>
          <h4>Location Details</h4>
          <div id="location-groups">
            <span><span>This location is available to group:</span> <span id="location-group-pills">${groupPills}</span></span>
            <span><b>Changes:</b> <audit-log href="/admin/domains/${this.domain_id}/audits"></audit-log></span>
          </div>
        </div>
        <div class="errors" data-cy="general-settings-errors"></div>
        <div>
          <label>Location/Business Name</label>
          <input type="text" id="location-settings-name" class="form-control" data-cy="location-settings-name" value="${this.data.site.location_name}">
          <label>Location Code</label>
          <input type="text" id="location-settings-code" class="form-control" data-cy="location-settings-code" value="${this.data.site.location_code || ""}" maxlength="50">
          <label>Industry</label>
          <select id="location-industry" is="industries-select" class="form-control" data-selected="${this.data.domain.industry_id}"  data-cy="location-settings-industry"></select>
          <label>Location Address</label>
          <input id="location-settings-address" class="form-control" data-cy="location-settings-address" value="${this.street_number && this.street_name && this.location_city ? `${this.street_number} ${this.street_name}, ${this.location_city}, ${this.location_state}, ${this.zip_code}, ${this.country}` : ""}">
        </div>
        <div class="col-sm-6 select-half-width-left">
          <label>Ideal Service Area</label>
          <select class="form-control" id="location-service-range-ideal" data-cy="location-service-range-ideal"></select>
        </div>
        <div class="col-sm-6 select-half-width-right">
          <label>Maximum Service Area</label>
          <select class="form-control" id="location-service-range-max" data-cy="location-service-range-max"></select>
        </div>
        <div>
          <label>Location Timezone</label>
          <select name="timezone" class="form-control" id="location-settings-timezone" data-cy="location-settings-timezone">
            <option value="US/Pacific" ${this.data.site.timezone == "US/Pacific" ? "selected" : null}>US/Pacific</option>
            <option value="US/Mountain" ${this.data.site.timezone == "US/Mountain" ? "selected" : null}>US/Mountain</option>
            <option value="US/Central" ${this.data.site.timezone == "US/Central" ? "selected" : null}>US/Central</option>
            <option value="US/Eastern" ${this.data.site.timezone == "US/Eastern" ? "selected" : null}>US/Eastern</option>
          </select>
        </div>

        <div class="location-settings-buttons">
          <button type="button" class="btn btn-primary save pull-right detail-row-button" data-cy="save-general-settings">Save</button>
          <button type="button" class="btn btn-outline-secondary cancel pull-right detail-row-button">Cancel</button>
        </div>
      </div>
      <div class="col-lg-4 col-md-hidden location-settings-main">
        ${LocationDocumentation.general_settings}
      </div>
      `;

      if(this.data.domain.inactive_details != null) {
        this.querySelector("#cancelled-location-container").appendChild(new ReactivateLocation(this.data, this.permissions))
      } else if (this.permissions.includes("admin:accounting:can_inactivate_location") && this.data.domain.inactive_details == null){
        this.querySelector(".location-settings-main").appendChild(new DeactivateLocation(this.data))
      }

      this.rangeOptions();
      this.initAddressAutoComplete();

      this.querySelector('.cancel').addEventListener('click', function() {
        this.resetData();
      }.bind(this))
      this.querySelector('.save').addEventListener('click', function() {
        this.save();
      }.bind(this))
  }

  rangeOptions() {
    let options = ['<option value="null">Choose</option>'];
    for(let i = 5; i <= 100; i+=5) {
      options.push(`<option value="${i}">${i} miles</option>`);
    }
    this.querySelector('#location-service-range-ideal').innerHTML = options.join('');
    this.querySelector('#location-service-range-ideal').value = this.data.site.service_range_ideal ? this.data.site.service_range_ideal : null;
    this.querySelector('#location-service-range-max').innerHTML = options.join('');
    this.querySelector('#location-service-range-max').value = this.data.site.service_range_max ? this.data.site.service_range_max : null;
  }

  initAddressAutoComplete() {
    let address1Field = this.querySelector("#location-settings-address");

    address1Field.addEventListener("change", function(e){
      if(e.target.value == "") {
        this.street_number = "";
        this.street_name = "";
        this.location_city = "";
        this.location_state = "";
        this.zip_code = "";
        this.country = "";
        this.latitude = "";
        this.longitude = "";
      }
    });
    
    // Create the autocomplete object, restricting the search predictions to
    // addresses in the US and Canada.
    this.autocomplete = new google.maps.places.Autocomplete(address1Field, {
      componentRestrictions: { country: ["us", "ca"] },
      fields: ["address_components", "geometry"],
    });
    // When the user selects an address from the drop-down, populate the
    // address fields in the form.
    this.autocomplete.addListener("place_changed", function() {
      this.fillInAddress(this.autocomplete)
    }.bind(this));
  }

  fillInAddress(autocomplete) {
    const place = autocomplete.getPlace();
     
    let street_number = "";
    let street_name = "";
    let city = "";
    let zip_code = "";
    let state = "";
    let country = "";
    let latitude = place.geometry.location.lat();
    let longitude = place.geometry.location.lng();
    for (const component of place.address_components) {
      const componentType = component.types[0];

      switch (componentType) {
        case "street_number": {
          street_number = `${component.long_name}`;
          break;
        }

        case "route": {
          street_name = component.short_name;
          break;
        }

        case "postal_code": {
          zip_code = `${component.long_name}${zip_code}`;
          break;
        }

        case "postal_code_suffix": {
          zip_code = `${zip_code}-${component.long_name}`;
          break;
        }
        case "locality":
          city = component.long_name;
          break;

        case "administrative_area_level_1": {
          state = component.short_name;
          break;
        }

        case "country": {
          country = component.short_name;
          break;
        }
      }
    }

    this.street_number = street_number;
    this.street_name = street_name;
    this.location_city = city;
    this.location_state = state;
    this.zip_code = zip_code;
    this.country = country;
    this.latitude = latitude;
    this.longitude = longitude;
  }

  show() {
    this.classList.remove('hidden');
  }

  hide() {
    this.classList.add('hidden');
  }

  async resetData() {
    if(await confirmPlus(`Are you sure you want to undo your changes?`)) {
      window.location.href = '/admin/domains';
    }
  }

  validate() {
    let isValid = true;
    let errors = "";
    this.querySelectorAll('.error').forEach(elem => {
      elem.classList.remove('error');
    })

    if(!this.querySelector('#location-settings-name').value.trim()) {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong>Warning!</strong> Please provide a location/business name.
                  </div>`;
      this.querySelector('#location-settings-name').classList.add('error')
      isValid = false;
    }
    if(this.querySelector('#location-industry').value == "null") {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong>Warning!</strong> Please choose an industry.
                  </div>`;
      this.querySelector('#location-industry').classList.add('error')
      isValid = false;
    }
    if(!this.querySelector('#location-settings-address').value) {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong>Warning!</strong> Please provide a location address.
                  </div>`;
      this.querySelector('#location-settings-address').classList.add('error')
      isValid = false;
    }
    if(parseInt(this.querySelector('#location-service-range-ideal').value) > parseInt(this.querySelector('#location-service-range-max').value)) {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong>Warning!</strong> Max service range cannot be greater than ideal service range.
                  </div>`;
      this.querySelector('#location-service-range-ideal').classList.add('error')
      this.querySelector('#location-service-range-max').classList.add('error')
      isValid = false;
    }
    if(!this.querySelector('#location-settings-timezone').value) {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong>Warning!</strong> Please provide a timezone.
                  </div>`;
      this.querySelector('#location-settings-timezone').classList.add('error')
      isValid = false;
    }

    this.querySelector('.errors').innerHTML = errors;
    return isValid;
  }

  async save() {
    if(this.validate()) {
      this.querySelector('.save').setAttribute("disabled", true);
      let data = {
        location_name: this.querySelector('#location-settings-name').value.trim(),
        location_code: this.querySelector('#location-settings-code').value,
        industry_id: this.querySelector('#location-industry').value,
        street_number: this.street_number,
        street_name: this.street_name,
        location_city: this.location_city,
        location_state: this.location_state,
        zip_code: this.zip_code,
        country: this.country,
        latitude: this.latitude,
        longitude: this.longitude,
        service_range_ideal: this.querySelector('#location-service-range-ideal').value,
        service_range_max: this.querySelector('#location-service-range-max').value,
        timezone: this.querySelector('#location-settings-timezone').value
      };
      let res = await fetch(`/admin/domains/${this.domain_id}/general_settings`, {
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                  'Content-type': 'application/json'},
        method: 'POST',
        body: JSON.stringify(data)
      })

      if (!res.ok) // or check for response.status
          throw new Error(res.statusText);
      
      let response = await res.json();
      if(response.success) {
        Common.notify('General settings updated', 'success');
      } else {
        Common.notify(`Unable to update general settings. ${response.error ? response.error : ""}`, 'error');
      }
      if(response.industry_updated) {
        document.querySelector('dealsaver-setup').reload(response.data)
      }
      this.querySelector('.save').removeAttribute("disabled");
    }
  }
}

customElements.define('general-settings', GeneralSettings)
